module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/developer/npm-d754e7a2bbf48f4a2901aef61fe6ef68.svg";